import { Controller } from "@hotwired/stimulus";
/**
 * Alternative Approach: https://christianheilmann.com/2020/11/26/back-to-basics-creating-a-clickable-card-interface-in-plain-html-css-and-javascript/
 */
export default class default_1 extends Controller {
    connect() {
        this.element.addEventListener("click", this.handleClick.bind(this));
    }
    /**
     * On click if
     *  - the target of the event was an A or a BUTTON or
     *  - the user has selected text
     * then we do nothing and let the browser do it's thing
     * Otherwise we click the source target which will fire all of it's events
     * If the source target is clicked then this listener will fire again…
     * but we have a check to see if the element was an A
     */
    handleClick(event) {
        var _a;
        const target = event.target;
        if (this.ignoreClick(target) || ((_a = window.getSelection()) === null || _a === void 0 ? void 0 : _a.toString())) {
            return;
        }
        this.locationTarget.click();
    }
    /**
     * Check the element and all it's parents
     * If the checked element is an A return true
     * If the checked element is an BUTTON return true
     * If the checked element does not have a parent element return true
     * If the checked element is this widget return false
     */
    ignoreClick(el) {
        while (el !== this.element) {
            let parentEl = el.parentElement;
            if (el.tagName === "A" || el.tagName === "BUTTON" || parentEl === null) {
                return true;
            }
            el = parentEl;
        }
        return false;
    }
}
default_1.targets = ["location"];
